document.addEventListener("DOMContentLoaded", function () {
  // Validación inicial: solo corre si la función está activada desde el administrador
  if (typeof theme === "undefined") {
    console.warn("[DYABOO ESCALONADO] ⚠️ 'theme' no está definido.");
    return;
  }
  if (typeof theme.settings === "undefined") {
    console.warn("[DYABOO ESCALONADO] ⚠️ 'theme.settings' no está definido.");
    return;
  }
  if (!theme.settings.tiered_messages_enabled) {
    console.log("[DYABOO ESCALONADO] ❌ Función desactivada desde settings");
    console.log(theme.settings);
    return;
  }
  console.log("[DYABOO ESCALONADO] 🟢 Función activa, iniciando verificación");
  console.log(theme.settings);

  // Utilidades
  function formatCurrency(value) {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    }).format(value);
  }

  function getCartSubtotal() {
    const totalElement = document.querySelector(".pt-cart-total-price");
    if (!totalElement) {
      console.warn("[DYABOO ESCALONADO] ⚠️ No se encontró el total del carrito");
      return 0;
    }
    const rawText = totalElement.textContent || "";
    return parseInt(rawText.replace(/\D/g, ""), 10) || 0;
  }

  function updateTieredDiscountMessage() {
    const msgContainer = document.querySelector(
      ".pt-descuento-monto-escalonado-msg"
    );
    if (!msgContainer) {
      console.warn("[DYABOO ESCALONADO] ⚠️ No se encontró el contenedor del mensaje escalonado");
      return;
    }

    const subtotal = getCartSubtotal();
    const tier1Amount = parseInt(theme.settings.tier_1_amount || "0", 10);
    const tier1Percent = theme.settings.tier_1_discount || "";
    const tier2Amount = parseInt(theme.settings.tier_2_amount || "0", 10);
    const tier2Percent = theme.settings.tier_2_discount || "";

    console.log(`[DYABOO ESCALONADO] 💰 Subtotal: ${subtotal}`);
    msgContainer.innerHTML = "";

    if (subtotal < tier1Amount) {
      const faltante = formatCurrency(tier1Amount - subtotal);
      msgContainer.innerHTML = `<div class='pt-aviso-escalonado'>Agrega ${faltante} más y obtén un ${tier1Percent}% de descuento 🟡</div>`;
    } else if (subtotal < tier2Amount) {
      const faltante = formatCurrency(tier2Amount - subtotal);
      msgContainer.innerHTML = `<div class='pt-aviso-escalonado'>¡Vas bien! Agrega ${faltante} más y recibirás un ${tier2Percent}% de descuento 🔵</div>`;
    } else {
      msgContainer.innerHTML = `<div class='pt-aviso-escalonado'>¡Felicidades! Aplica el ${tier2Percent}% de descuento 🟢</div>`;
    }
  }

  const cartList = document.querySelector(".pt-cart-list");
  if (cartList) {
    document.addEventListener("dyaboo:cart-updated", updateTieredDiscountMessage);
    updateTieredDiscountMessage();
    console.log("[DYABOO ESCALONADO] 🔄 Listener activo");
  } else {
    console.warn("[DYABOO ESCALONADO] ⚠️ No se encontró el contenedor de la lista del carrito (.pt-cart-list)");
  }
});
